import React, { Fragment, useEffect, useState } from "react";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import Checkbox from "@material-ui/core/Checkbox";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { green } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import { useSelector } from "../../../Redux";
import styles from "./CustomServiceMapping.module.css";
import { useTranslation } from "react-i18next";
import cloneDeep from "lodash-es/cloneDeep";
import { GetStateFromData } from "../../../components/CustomHooks/CustomHooks";

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const InitialState = {
  hoverItem: false,
  hoverIndex: null,
  dataObjectsContentIds: [],
};
export default function MultiSelectTreeView(props) {
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const { t } = useTranslation();
  const [iState, updateState] = useState(InitialState);
  const { hoverItem, hoverIndex, dataObjectsContentIds } = iState;

  const contexts = GetStateFromData();

  const { dataObjectsContent } = contexts.contexts;
  const { state, setState, indexUpload, defaultState } = props;
  const [updateStateCopy, setUpdateStateCopy] = useState({});
  let dataObjectsContentCopy = cloneDeep(dataObjectsContent);

  const recursiveTreeIds = (activeTreeNode, previousLevelId) => {
    for (let i in activeTreeNode) {
      let activeLevelId = previousLevelId.split(".").length;
      activeTreeNode[i][`level${activeLevelId}Id`] = `${previousLevelId}.${
        parseInt(i) + 1
      }`;
      if (
        Array.isArray(activeTreeNode[i].children) &&
        activeTreeNode[i].children.length > 0
      ) {
        recursiveTreeIds(
          activeTreeNode[i].children,
          `${previousLevelId}.${parseInt(i) + 1}`
        );
      }
    }
  };

  const createTreeIdsForDataSet = (treeData) => {
    for (let i in treeData) {
      let treeNode = treeData[i];
      if (Array.isArray(treeNode.children) && treeNode.children.length > 0) {
        for (let j in treeNode.children) {
          let treeNodeLevel1 = treeNode.children[j];
          treeNodeLevel1["level1Id"] = `${treeNode.VariableId}.${
            parseInt(j) + 1
          }`; //Id: x.1
          if (
            Array.isArray(treeNodeLevel1.children) &&
            treeNodeLevel1.children.length > 0
          ) {
            recursiveTreeIds(
              treeNodeLevel1.children,
              treeNodeLevel1["level1Id"]
            );
          }
        }
      }
    }
    return treeData;
  };

  useEffect(() => {
    if (dataObjectsContentIds.length === 0) {
      updateState({
        ...iState,
        dataObjectsContentIds: createTreeIdsForDataSet(dataObjectsContentCopy),
      });
      setUpdateStateCopy({
        ...iState,
        dataObjectsContentIds: createTreeIdsForDataSet(dataObjectsContentCopy),
      });
    }
    // }
  }, []);

  function dfs(node, term, foundIDS) {
    let isMatching =
      node.VariableName?.toLowerCase() &&
      node.VariableName?.toLowerCase().indexOf(term) > -1;
    if (Array.isArray(node.children)) {
      node.children.forEach((child) => {
        const hasMatchingChild = dfs(child, term, foundIDS);
        isMatching = isMatching || hasMatchingChild;
      });
    }
    if (isMatching && node.VariableName?.toLowerCase()) {
      foundIDS.push(node.VariableName?.toLowerCase());
    }
    return isMatching;
  }

  function searchDO(data, matchedIDS) {
    return data
      .filter(
        (item) => matchedIDS.indexOf(item.VariableName?.toLowerCase()) > -1
      )
      .map((item) => ({
        ...item,
        children: item.children ? searchDO(item.children, matchedIDS) : [],
      }));
  }

  function search1(term) {
    const dataNode = {
      children: iState.dataObjectsContentIds,
    };
    const matchedIDS = [];
    dfs(dataNode, term, matchedIDS);
    return searchDO(iState.dataObjectsContentIds, matchedIDS);
  }

  useEffect(() => {
    if (props.searchValue?.length > 0 || props.searchValue === "") {
      setUpdateStateCopy({
        ...iState,
        dataObjectsContentIds: search1(props.searchValue?.toLowerCase()),
      });
    }
  }, [props.searchValue]);

  function setfilter(data, node) {
    return data.map((item) => {
      const newItem = {
        ...item,
        ...(node.VariableName === item.VariableName
          ? { mappedinput: node.treeName }
          : item?.mappedinput
          ? { ...item }
          : { mappedinput: null }),
        name: item.VariableName,
        title: `${item.VariableType}(${item.VariableLength})`,
        mappeddatafield: item.treeName,
        Precision: item.VarPrecision,
        ...(item.children ? { children: item?.children } : ""),
        children: item.children ? setfilter(item.children, node) : [],
      };
      return newItem;
    });
  }

  function unsetfilter(data, node) {
    let result = data.map((item) => {
      const itemCopy = cloneDeep(item || null);
      if (node.VariableName === itemCopy.VariableName) {
        itemCopy.mappedinput = null;
      }
      return {
        ...itemCopy,
        children: itemCopy.children ? unsetfilter(itemCopy.children, node) : [],
      };
    });
    return result;
  }
  const setMapping = (e, node) => {
    let temp = state;
    let setFilterObj = setfilter(dataObjectsContentIds, node);
    let setFilterObjCopy = setfilter(
      updateStateCopy.dataObjectsContentIds,
      node
    );
    temp[indexUpload]["InputParams"] = setFilterObjCopy;
    setState(temp);
    updateState({ ...iState, dataObjectsContentIds: setFilterObj });
    setUpdateStateCopy({ ...iState, dataObjectsContentIds: setFilterObjCopy });
  };
  const unSetMapping = (e, node) => {
    let temp = state;
    let unsetFilterObj = unsetfilter(dataObjectsContentIds, node);
    let unsetFilterObjCopy = unsetfilter(
      updateStateCopy.dataObjectsContentIds,
      node
    );
    temp[indexUpload]["InputParams"] = unsetFilterObjCopy;
    setState(temp);
    updateState({ ...iState, dataObjectsContentIds: unsetFilterObj });
    setUpdateStateCopy({
      ...iState,
      dataObjectsContentIds: unsetFilterObjCopy,
    });
  };

  console.log(
    indexUpload,
    "==========",
    dataObjectsContentIds,
    "........",
    state,
    "defaultState",
    defaultState
  );

  const renderTree = (nodes) => {
    return (
      nodes &&
      nodes.map((d, index) => {
        let children = undefined;
        let itemId = "";
        if (d.hasOwnProperty("SystemDefinedName")) {
          itemId = d.VariableId.toString();
        } else if (d.hasOwnProperty("ColumnName")) {
          let keysArr = Object.keys(d);
          let idPos = "";
          keysArr.forEach((i) => {
            if (i.includes("level")) {
              idPos = i;
            }
          });
          itemId = d[idPos];
        } else if (d.type === null) {
          return;
        }
        if (d.children && d.children.length > 0) {
          children = renderTree(d.children);
        }

        function exists(treeName) {
          function hasAnyMapped(item) {
            if (item.mappedinput) return true;
            return Array.isArray(item.children) && item.children.some(hasAnyMapped);
          }
          function checkNode(item) {
            if (item.treeName === treeName) return hasAnyMapped(item);
            return Array.isArray(item.children) && item.children.some(checkNode);
          }
          return props?.defaultInputParam?.some(checkNode) ?? false;
        }

        return (
          <Fragment key={itemId}>
            <TreeItem
              tabIndex="-1"
              className="CustomTreeItem"
              id={itemId}
              key={itemId}
              nodeId={itemId}
              label={
                <div className="d-flex justify-content-between">
                  <div className={styles.CustomLabel}>
                    <span
                      style={
                        translationStyles1
                          ? { marginRight: "-9px" }
                          : { marginLeft: "-9px" }
                      }
                    >
                      {(d.mappedinput && d.mappedinput !== null) ||
                      exists(d.treeName) ? (
                        <GreenCheckbox
                          icon={
                            <FiberManualRecordOutlinedIcon
                              style={{ fontSize: "13px", color: "black" }}
                            />
                          }
                          checkedIcon={
                            <FiberManualRecordIcon
                              style={{ fontSize: "13px", marginTop: "-3px" }}
                            />
                          }
                          checked={true}
                        />
                      ) : (
                        <GreenCheckbox
                          icon={
                            <FiberManualRecordOutlinedIcon
                              style={{ fontSize: "13px", color: "black" }}
                            />
                          }
                          checkedIcon={
                            <FiberManualRecordIcon
                              style={{ fontSize: "13px", marginTop: "-3px" }}
                            />
                          }
                          checked={false}
                        />
                      )}
                    </span>
                    <span title={d.VariableName}>
                      <>{d.VariableName}</>
                    </span>
                    {hoverIndex === itemId &&
                    hoverItem &&
                    (!d.mappedinput || d.mappedinput === null) ? (
                      <button
                        className={styles.mapButtonStyle}
                        style={{
                          margin: "0px !impoertant",
                          marginLeft: "20px !important",
                          borderRadius: "3px",
                          width: "65px",
                          marginBottom: "5px !important",
                          marginTop: "5px",
                        }}
                        onClick={(event) => setMapping(event, d)}
                      >
                        {" "}
                        {t("Select")}{" "}
                      </button>
                    ) : hoverIndex === itemId &&
                      hoverItem &&
                      d.mappedinput &&
                      d.mappedinput !== null ? (
                      <button
                        className={styles.mapButtonStyle}
                        style={{
                          margin: "0px !impoertant",
                          marginLeft: "20px !important",
                          borderRadius: "3px",
                          width: "65px",
                          marginBottom: "5px !important",
                          marginTop: "5px",
                        }}
                        onClick={(event) => unSetMapping(event, d)}
                      >
                        {" "}
                        {t("Unselect")}{" "}
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              }
              children={children}
              onMouseOver={(e) => {
                e.stopPropagation();
                updateState({ ...iState, hoverItem: true, hoverIndex: itemId });
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                updateState({ ...iState, hoverItem: false, hoverIndex: null });
              }}
            />
          </Fragment>
        );
      })
    );
  };

  return (
    <TreeView
      aria-label="multi-select"
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      multiSelect
      sx={{ height: 216, flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
    >
      {updateStateCopy.dataObjectsContentIds &&
        renderTree(updateStateCopy.dataObjectsContentIds)}
    </TreeView>
  );
}
